import { render, staticRenderFns } from "./helpActRank.vue?vue&type=template&id=53da3efa&scoped=true&"
import script from "./helpActRank.vue?vue&type=script&lang=js&"
export * from "./helpActRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da3efa",
  null
  
)

export default component.exports